import Lenis from 'lenis';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { SplitText } from "gsap/SplitText";
// import { ScrollSmoother } from "gsap/ScrollSmoother";
// import ScrollSmoother from 'gsap-trial/ScrollSmoother';

// import Swiper from 'swiper';import 'swiper/css';

// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

import lightGallery from 'lightgallery';
import lgVideo from 'lightgallery/plugins/video';
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-video.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgFullscreen from 'lightgallery/plugins/fullscreen';
import lgZoom from 'lightgallery/plugins/zoom';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import 'lightgallery/css/lg-fullscreen.css';

//  import 'lightgallery/css/lightgallery.css';

// import Swiper from 'swiper';
// import 'swiper/css';
// import Swiper styles;

// import CustomEase from "gsap/CustomEase";
// import DrawSVGPlugin from "gsap/DrawSVGPlugin";
// import MotionPathPlugin from "gsap/MotionPathPlugin";
// import {closestEdge} from 'utils';
// import Observer from "gsap/Observer";

gsap.registerPlugin(ScrollTrigger,SplitText);
// gsap.registerPlugin(CustomEase);
// gsap.registerPlugin(DrawSVGPlugin);
// gsap.registerPlugin(MotionPathPlugin);
// gsap.registerPlugin(ScrollSmoother)
/*
ScrollSmoother.create({
  smooth: 2,
  effects: true
});
*/

gsap.config({
    nullTargetWarn: !1
});

const lenis = new Lenis({
    // lerp: 0.05,
    // lerp: 0.1,
    wheelMultiplier: 0.6,
    /*
    duration: 1.2,
    easing: (t) => (t === 1 ? 1 : 1 - Math.pow(2, -10 * t)),
    direction: "vertical",
    gestureDirection: "vertical",
    smooth: true,
    smoothTouch: false,
    touchMultiplier: 1,
    */
});
function raf(time) {
    lenis.raf(time),
    ScrollTrigger.update(),
    requestAnimationFrame(raf)
}
requestAnimationFrame(raf);


// Synchronize Lenis scrolling with GSAP's ScrollTrigger plugin
// lenis.on('scroll', ScrollTrigger.update);

// ScrollSmoother.create({
//     wrapper: '.home',
//     smooth: 2,
//     effects: true,
//     normalizeScroll: true
// });

// require ('./highlight_text.js');

function scrollToAnchor(hash) {
    var target = jQuery(hash),headerHeight = 0;

    if(jQuery('.filter-categories').length>0){
        jQuery('.filter-categories').find('a[data-filterslug="'+hash.slice(1)+'"]').trigger('click');
    }

    target = target.length ? target : jQuery('[name=' + hash.slice(1) +']');
    if (target.length)
    {
        jQuery('html,body').animate({
            scrollTop: target.offset().top - headerHeight
        }, 400);
        return false;
    }
    
}

function fitImage(img, marginFactor) {
	let sx = img.parentNode.offsetWidth / img.naturalWidth,
		sy = img.parentNode.offsetHeight * (1 + Math.abs(marginFactor)) / img.naturalHeight,
		scale = Math.max(sx, sy),
		w = Math.ceil(img.naturalWidth * scale),
		h = Math.ceil(img.naturalHeight * scale);
        console.log(scale);
	// gsap.set(img, {width: w, height: h, top: Math.ceil((img.parentNode.offsetHeight - h) / 2), left: Math.ceil((img.parentNode.offsetWidth - w) / 2), position: "absolute"});
	gsap.set(img, {scale: scale});
}


(function() {
    var scroll;//
    var w_w,main_w,page_w,content_w;
    var windowHeight;
    var percent_of_element;
    var green_add;
    var blue_add;
    var bg_left;
    var footer_h;
    var max_width_content;
    var body_elem;
    var custom_cursor_height,custom_cursor_width;



    /* get direction from*/
    function gestureDirectionFrom(e,$this){
        var directions = ['top', 'right', 'bottom', 'left'];
        var w = $this.offsetWidth;
        var h = $this.offsetHeight;
        var x = (e.clientX - $this.getBoundingClientRect().left - (w / 2)) * (w > h ? (h / w) : 1);
        var y = (e.clientY - $this.getBoundingClientRect().top - (h / 2)) * (h > w ? (w / h) : 1);
        // Calculate the angle to the center the pointer entered/exited
        // and convert to clockwise format (top/right/bottom/left = 0/1/2/3).
        var d = Math.round(Math.atan2(y, x) / 1.57079633 + 5) % 4;
        return directions[d];
    }


    /* check direction and add effect over hover*/
    function checkDirectionAndEffect(items){
        if(items.length && typeof items == 'object'){
            for(var i = 0; i < items.length; i++){
                items[i].onmouseenter = function(e){
                    var direction = gestureDirectionFrom(e,this);
                    var overlay = this.getElementsByClassName('overlay')[0];
                    if(!overlay) return false;
                    switch(direction){
                        case "left":
                            overlay.style.top = "0%";
                            overlay.style.left = "-100%";
                            gsap.to(overlay, .5, {left: '0%'});
                            break;
                        case "right":
                            overlay.style.top = "0%";
                            overlay.style.left = "100%";
                            gsap.to(overlay, .5, {left: '0%'});
                            break;
                        case "top":
                            overlay.style.top = "-100%";
                            overlay.style.left = "0%";
                            gsap.to(overlay, .5, {top: '0%'});
                            break;
                        case "bottom":
                            overlay.style.top = "100%";
                            overlay.style.left = "0%";
                            gsap.to(overlay, .5, {top: '0%'});
                            break;
                    }
                };
                items[i].onmouseleave = function(e){
                    var direction = gestureDirectionFrom(e,this);
                    var overlay = this.getElementsByClassName('overlay')[0];
                    switch(direction){
                        case "left":
                            gsap.to(overlay, .5, {left: '-100%'});
                        break;
                        case "right":
                            gsap.to(overlay, .5, {left: '100%'});
                        break;
                        case "top":
                            gsap.to(overlay, .5, {top: '-100%'});
                        break;
                        case "bottom":
                            gsap.to(overlay, .5, {top: '100%'});
                        break;
                    }
                };
            }
        }
    }

    /* Detect Closest Edge
    ***************************************************************************/
    function closestEdge(x,y,w,h) {
        var topEdgeDist = distMetric(x,y,w/2,0);
        var bottomEdgeDist = distMetric(x,y,w/2,h);
        var leftEdgeDist = distMetric(x,y,0,h/2);
        var rightEdgeDist = distMetric(x,y,w,h/2);
        var min = Math.min(topEdgeDist,bottomEdgeDist,leftEdgeDist,rightEdgeDist);
        switch (min) {
            case leftEdgeDist:
                return "left";
            case rightEdgeDist:
                return "right";
            case topEdgeDist:
                return "top";
            case bottomEdgeDist:
                return "bottom";
        }
    }

    /* Distance Formula
    ***************************************************************************/
    function distMetric(x,y,x2,y2) {
        var xDiff = x - x2;
        var yDiff = y - y2;
        return (xDiff * xDiff) + (yDiff * yDiff);
    }
    
    //check jquery
    if (typeof jQuery === "function" || typeof $ === "function") {
        var $ = jQuery.noConflict();


        jQuery.fn.extend({
            live: function (event, callback) {
            if (this.selector) {
                    jQuery(document).on(event, this.selector, callback);
                }
                return this;
            }
        });
        jQuery.fn.isInViewport = function() {
            // var elementTop = $(this).offset().top;
            // var elementBottom = elementTop + $(this).outerHeight();
            // var viewportTop = $(window).scrollTop();
            // var viewportBottom = viewportTop + $(window).height();
            // return elementBottom > viewportTop && elementTop < viewportBottom;

            // if the element doesn't exist, abort
            var elem = $(this);
            if( elem.length == 0 ) {
                return;
            }
            var $window = jQuery(window)
            var viewport_top = $window.scrollTop()
            var viewport_height = $window.height()
            var viewport_bottom = viewport_top + viewport_height
            var $elem = jQuery(elem)
            var top = $elem.offset().top
            var height = $elem.height()
            var bottom = top + height

            return (top >= viewport_top && top < viewport_bottom) ||
                (bottom > viewport_top && bottom <= viewport_bottom) ||
                (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
        };
        
        body_elem = jQuery("body"); var header_offset = !!body_elem.length && body_elem.offset().top + 50;var y_scroll_pos_prev = 0;
        function site_scrolled(){
            var e = window.pageYOffset;
            body_elem = jQuery("body");
            e > header_offset ? (body_elem.removeClass("sitescroll-inactive"), body_elem.addClass("sitescroll-active")) : (body_elem.removeClass("sitescroll-active"), body_elem.addClass("sitescroll-inactive")),
                y_scroll_pos_prev >= e ? (body_elem.removeClass("sitescroll-down"), body_elem.addClass("sitescroll-up")) : (body_elem.removeClass("sitescroll-up"), body_elem.addClass("sitescroll-down")),
                e <= 200 ? body_elem.addClass("sitescroll-between") : body_elem.removeClass("sitescroll-between"),
                (y_scroll_pos_prev = e);
        }
        function FullLeftOrRight(){
            setTimeout(function(){
                if(content_w<w_w && w_w>767){
                    let size = (main_w -content_w)/2;
                    //if(size>200) size = 200;
                    // console.log(size);
                    $('.vc_row_inner_fullright').css({'width': size+content_w + 30});
                    $('.vc_row_inner_fullleft').css({'width': size+content_w + 30});
                }else{
                    $('.vc_row_inner_fullright').css({'width': 'auto'});
                    $('.vc_row_inner_leftright').css({'width': 'auto'});
                }
            },100);
        }
        /* ---------------- CUSTOM CURSOR */
        function addCursorHover(hoveredElement, selectedElement, newClass) {
            jQuery(hoveredElement).hover(function() {
                jQuery(selectedElement).addClass(newClass);
            }, function() {
                jQuery(selectedElement).removeClass(newClass);
            });
        }
        function addCursorDrag(hoveredElement, selectedElement, newClass) {
            jQuery(hoveredElement).mousedown(function() {
                jQuery(selectedElement).addClass(newClass);
            });
            jQuery("body").mouseup(function() {
                jQuery(selectedElement).removeClass(newClass)
            });
            
        }
        var custom_cursor_width = custom_cursor_height = 0;
        function customCursor(){
            if(!$('#custom_cursor').length)
            $('body').append('<div class="cursor" id="custom_cursor"><div class="cursor__cirlce"><div class="cursor__arrow"></div></div></div>');
            var cursor = $("#custom_cursor");
            var posX = 0,posY = 0;
            var mouseX = 0,mouseY = 0;
            custom_cursor_width = $('#custom_cursor').width();
            //console.log(custom_cursor_width);
            gsap.to({}, 0.016, {
                repeat: -1,
                onRepeat: function() {
                    posX += (mouseX - posX) / 9;
                    posY += (mouseY - posY) / 9;
                    gsap.set(cursor, {
                    css: {
                    left: mouseX- (custom_cursor_width/2),
                    top: mouseY- (custom_cursor_width/2)
                        }
                    });
                }
            });
            $('.key_notes_slider .swiper-wrapper').on("mousemove", function(e) {
            mouseX = e.clientX;
            mouseY = e.clientY;
            });
        }

        function checkFloatLeftRight(){
            var check;
            setTimeout(function(){
                check = (w_w - content_w) /2;
                // if(check>150) check = 150;
                //for left
                if(w_w > 768) {
                    if(jQuery('.floatleft.wpb_column')) {
                        jQuery('.floatleft.wpb_column > .vc_column-inner').css({'margin-left': -1*check});
                    }
                }else{
                    jQuery('.floatleft.wpb_column > .vc_column-inner').css({'margin-left': 0});
                }
                //for right
                if(w_w > 768) {
                    if(jQuery('.floatright.wpb_column')) {
                        jQuery('.floatright.wpb_column > .vc_column-inner').css({'margin-right': -1*check});
                    }
                }else{
                    jQuery('.floatright.wpb_column > .vc_column-inner').css({'margin-right': 0});
                }
            },50);
        }

        window.addEventListener("scroll",function(){
            site_scrolled();
        });
        window.addEventListener('resize', function(){
            w_w = $(window).width();
            main_w = $('#main').width();
	        content_w = $('#content').width();
	        page_w = $('#page').width();
            site_scrolled();
            FullLeftOrRight();
            
            checkFloatLeftRight();
        });
        
 
        // window.addEventListener('load', function(){
        window.addEventListener('DOMContentLoaded', function(){
        // jQuery(function($){

            // const pageEnd = performance.mark('pageEnd');
            // Calculate the load time in seconds
            // performance.mark().startTime provides the timestamp in milliseconds
            // loadTime = pageEnd.startTime / 1000;

            w_w = $(window).width();
            main_w = $('#main').width();
	        content_w = $('#content').width();
	        page_w = $('#page').width();
            
            FullLeftOrRight();

            site_scrolled();

            checkFloatLeftRight();

            //home header video
            (function(){
                $('#row_under_hero').css({'min-height': (w_w*9)/16 - 100});
                const timeline = gsap.timeline({
                    scrollTrigger: {
                        trigger: "#home_header",
                        start: "top top", 
                        end: "center top",
                        scrub: true,
                    },
                });
                timeline.to("#header_video .wpb_wrapper", {
                    // x: '-20%',
                    x: -((w_w+1) - content_w)/2,
                    // y: '-15%',
                    y: 0,
                    width: "100vw",
                    height: (w_w*9)/16,
                    // height: "100vh", 
                    ease: "none",
                });

                /*
                const timeline2 = gsap.timeline({
                    scrollTrigger: {
                        trigger: "#home_header",
                        start: "top top", 
                        end: "center top",
                        scrub: true,
                    },
                });
                timeline2.to(".home_header_heading1",{
                    x: '-5%',
                    markers: true,
                    }
                );
                timeline2.to(".home_header_heading2",{
                    x: '5%',
                    }
                );
                timeline2.to(".home_header_heading3",{
                    x: '10%',
                    }
                );
                */

                const timeline3 = gsap.timeline({
                    scrollTrigger: {
                        trigger: "#header_video",
                        start: "top+=200 bottom", 
                        // end: "center top",
                        scrub: true,
                        // markers: true,
                    },
                });
                timeline3.to("#header_video img", {
                    y: '0',
                    opacity: 1,
                    scale: 1,
                    ease: "none",
                    // scrub: true,
                });

                //for timer
                const timeline4 = gsap.timeline({
                    scrollTrigger: {
                        trigger: "#video_timer",
                        start: "top+=60% bottom", 
                        // end: "bottom top",
                        // scrub: true,
                        // markers: true,
                        toggleActions: "restart none none reset"
                    },
                });
                timeline4.to("#video_timer", {
                    y: '0',
                    opacity: 1,
                    // scale: 1,
                    ease: "none",
                    // scrub: true,
                });

                //timer
                if( $('#hero_video').length ){
                    const video = document.getElementById('hero_video');
                    const timerDisplay = $('#video_timer');

                    function formatTime(seconds) {
                        const minutes = Math.floor(seconds / 60);
                        const remainingSeconds = Math.floor(seconds % 60);
                        return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`;
                    }

                    video.addEventListener('timeupdate', () => {
                        const currentTime = video.currentTime;
                        const duration = video.duration;
                            
                        var val = 100*(currentTime)/ duration;
                        if (!isNaN(duration)) {
                            // timerDisplay.find('div').width = `${formatTime(currentTime)} / ${formatTime(duration)}`;
                            timerDisplay.find('div').css('width', val+'%');
                        } else {
                            timerDisplay.find('div').css('width', val+'%');
                        }
                    });
                }
            })();

            (function(){
                // return false;
                $('.mm_video_lightbox').each(function(){
                    var id = $(this).attr('id');
                    lightGallery(document.getElementById(id),{
                        licenseKey: 'your_key',
                        plugins: [lgVideo],
                        download: false,
                        share: false,
                        counter: false,
                        mobileSettings: {
                            counter: false,
                            controls: false,
                            showCloseIcon: true,
                            download: false,
                        }
                    });
                });
            })();

            (function(){
                var movementFactor = 0.15;
                let getRatio = el => window.innerHeight / (window.innerHeight + el.offsetHeight);
                setTimeout(function(){
                    var items;
                    items = gsap.utils.toArray(".vc_column_inner_bg,.ourservices_img,.ult_ib_img_parallax");
                    items.forEach( section => {
                    // section.bg = section.querySelector(".vc_column_inner_bg"); 
                    // Give the backgrounds some random images
                    // section.bg.style.backgroundImage = 'url(http://localhost/mmspace.com.au/play-to-learn/site/wp-content/uploads/2025/12/home-testimonials2-min.jpg)';
                    // console.log(getRatio(section.parentNode));
                    // the first image (i === 0) should be handled differently because it should start at the very top.
                    // use function-based values in order to keep things responsive
                    // console.log(i);
                    gsap.fromTo(section, {
                        // backgroundPosition: () => i ? `50% ${-window.innerHeight * getRatio(section.parentNode)}px` : "50% 0px"
                            backgroundPosition: "50% 0px",
                        }, {
                            backgroundPosition: () => `50% ${window.innerHeight * (1 - getRatio(section.parentNode))}px`,
                            // backgroundPosition: `50% ${innerHeight / 2}px`,
                            ease: "none",
                            scrollTrigger: {
                            trigger: section.parentNode,
                            // start: () => i ? "top bottom" : "top top", 
                            start: "top top",
                            end: "bottom top",
                            scrub: true,
                            invalidateOnRefresh: true, // to make it responsive
                            // markers: true,
                            }
                        });
                    });
                },100);
            })();


            //------------------------------------ Why Us
            (function(){
                var total_item;
                var swiper;
                jQuery('.why_us_buttons a').click(function(e){
                    e.preventDefault();
                });
                var max_h = 0;
                setTimeout(function(){
                    jQuery('.why_us_heading').each(function(){
                        if(jQuery(this).height() > max_h) max_h = jQuery(this).height();
                    });
                    jQuery('.why_us_heading').height(max_h);
                    jQuery('.why_us_heading_wrap_inner').height(max_h);

                    max_h = 0;
                    jQuery('.why_us_desc').each(function(){
                        if(jQuery(this).height() > max_h) max_h = jQuery(this).height();
                    });
                    jQuery('.why_us_desc').height(max_h);
                    jQuery('.why_us_text_wrap_inner').height(max_h);
                },200);


                var current_item = 1;
                total_item = jQuery('.why_us_heading').length;
                $('.why_us_buttons .next').click(function(){
                    var change_to;
                    if(current_item<total_item){
                        current_item++;
                    }else if(current_item==total_item){
                        current_item = 1;
                    }
                    //
                    let number = current_item;
                    number = (eval(number)-1)*100*-1;
                    //if(number!=1) $('.why_us_heading_wrap_inner').css({'transform' : 'translateY('+number+'%)'});
                    //else $('.why_us_heading_wrap_inner').css({'transform' : 'translateY(0)'});

                    $('.why_us_text_wrap_inner').css({'transform' : 'translateY('+number+'%)'});
                    $('.why_us_heading_wrap_inner').css({'transform' : 'translateY('+number+'%)'});

                    swiper.slideNext();
                });

                $('.why_us_buttons .prev').click(function(e){
                    if(current_item==1){
                        return false;
                    }else if(current_item<total_item){
                        current_item--;
                    }else if(current_item==total_item){
                        current_item--;
                    }
                    //
                    let number = current_item;
                    number = (eval(number)-1)*100*-1;
                    //if(number!=1) $('.why_us_heading_wrap_inner').css({'transform' : 'translateY('+number+'%)'});
                    //else $('.why_us_heading_wrap_inner').css({'transform' : 'translateY(0)'});

                    $('.why_us_text_wrap_inner').css({'transform' : 'translateY('+number+'%)'});
                    $('.why_us_heading_wrap_inner').css({'transform' : 'translateY('+number+'%)'});
                    swiper.slidePrev();
                });
                
                swiper = new Swiper(".why_us_swiper", {
                    slidesPerView: 1.5,
                    spaceBetween: 60,
                    loop: true,
                    speed: 800,
                    grabCursor: false,
                    allowTouchMove: false,
                    // centeredSlides: true,
                    // grabCursor: true,
                    //effect: fade, cube, coverflow, flip, cards, creative

                    // effect: "cards",
                    // cardsEffect: {
                    //     perSlideOffset: 10,
                    //     perSlideRotate: 2,
                    //     rotate: true,
                    //     slideShadows: true,
                    // },

                    effect: "creative",
                    creativeEffect: {
                        prev: {
                            // shadow: true,
                            // translate: ["-120%", 0, -500],
                            translate: ["-105%", 0, 0],
                            scale: 0.75,
                            origin: 'left top',
                        },
                        next: {
                            // shadow: true,
                            // translate: ["120%", 0, -500],
                            translate: ["105%", 0, 0],
                            scale: 0.75,
                            origin: 'left top',
                        },
                    },
                    
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    breakpoints: {
                        // when window width is >= 640px
                        200: {
                            slidesPerView: 1,
                        },
                        767: {
                            slidesPerView: 1.2,
                            spaceBetween: 10,
                        },
                        1024: {
                            slidesPerView: 1.3,
                        },
                        1400: {
                            slidesPerView: 1.4,
                        },
                        1679: {
                            slidesPerView: 1.5,
                        },
                        2000: {
                            slidesPerView: 1.5,
                        },
                    },
                });
                
                swiper.on('slideChange', function(){
                    if (swiper.realIndex > swiper.previousIndex) {
                        //$('.why_us_buttons .next').trigger('click');
                        console.log('next');
                    }else if(swiper.realIndex < swiper.previousIndex) {
                        //$('.why_us_buttons .prev').trigger('click');
                        console.log('prev');
                    }
                    
                });
                
            })();

            /* -------------------------------------- custom Image carousel lightbox */
            (function(){
                $('.mode_swiper_gallery').each(function(index, el){
                    var $this = $(this);
                    var $swiperEl = $this.find('.swiper');
                    if (!$swiperEl.length) return;
                    let swiper = new Swiper($swiperEl[0], {
                        slidesPerView: 1,
                        // slidesPerView: 'auto',
                        spaceBetween: 30,
                        observer: true,
                        observeParents: true,
                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true,
                        },
                        scrollbar: {
                            el: '.swiper-scrollbar',
                            draggable: true,
                        },
                        breakpoints: {
                            // when window width is >= 640px
                            200: {
                                slidesPerView: 1,
                            },
                            480: {
                            //    slidesPerView: 1.4, 
                            },
                            1024: {
                                slidesPerView: 2,
                            },
                            1100: {
                                slidesPerView: 3,
                            },
                            1921: {
                                slidesPerView: 4,
                            },
                        },
                    });

                    var id = $(this).attr('id');
                    lightGallery(document.getElementById(id),{
                        licenseKey: 'your_key',
                        plugins: [lgZoom, lgThumbnail,lgFullscreen],
                        thumbnail: true,
                        selector:'.swiper-slide',
                        download: false,
                        share: false,
                        counter: false,
                    });
                });
            })();

            // ------ heading 
            (function(){
                var items = document.querySelectorAll(".vc_custom_heading.appear_effect,#footer");
                ScrollTrigger.batch(items, {
                    onEnter: batch => {
                        batch.forEach( (el, index) =>{
                            el.classList.add('view')
                        })
                    },
                    start: "top+=60 bottom",
                })
            })();



            (function(){
                const cards = document.querySelectorAll(".ult-new-ib");
                cards.forEach((card) => {
                    card.addEventListener("mousemove", (e) => {
                        const rect = card.getBoundingClientRect();
                        const x = (e.clientX - rect.left) / rect.width;
                        const y = (e.clientY - rect.top) / rect.height;
                        const xDeg = (y - 0.5) * 8;
                        const yDeg = (x - 0.5) * -8;
                        // card.style.transform = `perspective(1200px) rotateX(${xDeg}deg) rotateY(${yDeg}deg)`;

                        
                        const layers = card.querySelectorAll(".ult_ib_img_parallax");
                        layers.forEach((layer, index) => {
                            const depth = 30 * (index + 1);
                            const translateZ = depth;
                            const offsetX = (x - 0.5) * 10 * (index + 1);
                            const offsetY = (y - 0.5) * 10 * (index + 1);
                            layer.style.transform = `translate3d(${offsetX}px, ${offsetY}px, ${translateZ}px)`;
                        });
                        
                    });
                    card.addEventListener("mouseleave", () => {
                        card.style.transform = "";
                        const layers = card.querySelectorAll(".ult_ib_img_parallax");
                        layers.forEach((layer, index) => {
                            layer.style.transform = "";
                        });
                    });
                });
            })();


            (function(){
                const items = document.querySelectorAll(".ourservices_wrapper");
                items.forEach((item) => {
                    item.addEventListener("mousemove", (e) => {
                        const rect = item.getBoundingClientRect();
                        const x = (e.clientX - rect.left) / rect.width;
                        const y = (e.clientY - rect.top) / rect.height;
                        const xDeg = (y - 0.5) * 8;
                        const yDeg = (x - 0.5) * -8;
                        // item.style.transform = `perspective(1200px) rotateX(${xDeg}deg) rotateY(${yDeg}deg)`;

                        
                        const layers = item.querySelectorAll(".ourservices_img");
                        layers.forEach((layer, index) => {
                            const depth = 30 * (index + 1);
                            const translateZ = depth;
                            const offsetX = (x - 0.5) * 10 * (index + 1);
                            const offsetY = (y - 0.5) * 10 * (index + 1);
                            layer.style.transform = `translate3d(${offsetX}px, ${offsetY}px, ${translateZ}px)`;
                        });
                        
                    });
                    item.addEventListener("mouseleave", () => {
                        item.style.transform = "";
                        const layers = item.querySelectorAll(".ourservices_img");
                        layers.forEach((layer, index) => {
                            layer.style.transform = "";
                        });
                    });
                });
            })();


            /* -------- Our VIP services*/
            setTimeout(function () {
                var img_parallax = gsap.utils.toArray(".ourservices_wrapperRRRR img");
                var movementFactor = 0.2;
                img_parallax.forEach(function (img, i) {
                fitImage(img, movementFactor);
                i = 1;
                // the first image (i === 0) should be handled differently because it should start at the very top.
                // use function-based values in order to keep things responsive
                gsap.fromTo(img, {
                    y: function y() {
                    return i ? -movementFactor * 0.9 * img.parentNode.offsetHeight : 0;
                    }
                }, {
                    y: function y() {
                    return movementFactor * 0.9 * img.parentNode.offsetHeight;
                    },
                    ease: "linear",
                    // ease: "power1.out",
                    scrollTrigger: {
                    trigger: img.parentNode,
                    start: function start() {
                        return i ? "top bottom" : "-1px top";
                    },
                    end: "bottom top",
                    scrub: true,
                    invalidateOnRefresh: true // to make it responsive
                    }
                });
                });
            }, 200);

            //--- carousel
            /*
            (function(){
                setTimeout(function(){
                    // var items = document.querySelectorAll(".dt-owl-item:not(.cloned),.info_list_item");
                    var items = document.querySelectorAll(".dt-owl-item,.info_list_item");
                    ScrollTrigger.batch(items, {
                        onEnter: batch => {
                            batch.forEach( (el, index) =>{
                                gsap.delayedCall(index*0.3, ()=>{
                                    el.classList.add('view');
                                });
                            })
                        },
                        start: "top+=60 bottom",
                    })
                },100);
            })();
            */


            // ------ block text
            (function(){
                var items = document.querySelectorAll(".wpb_text_column,.ubtn-ctn-left,.ubtn-ctn-right,.ubtn-ctn-center,.frames");
                ScrollTrigger.batch(items, {
                    onEnter: batch => {
                        batch.forEach( (el, index) =>{
                            gsap.delayedCall(index*0.3, ()=>{
                                el.classList.add('view');
                            });
                        })
                    },
                    start: "top+=60 bottom",
                })
            })();

            /*
            if(window.location.hash) {
                setTimeout(function(){
                    scrollToAnchor(window.location.hash);
                },300);
            }
            jQuery("a[href*='#']:not([href='#'])").on('click', function(e) {
                // e.preventDefault();
                if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') || location.hostname == this.hostname){
                    scrollToAnchor(this.hash);
                }
            });
            */

            (function(){
                var total =  $('.portfolio-carousel-shortcode article.post').length;
                if(total<10) total = '0'+total;
                $('.portfolio-carousel-shortcode article.post').each(function(){
                    let index = $(this).index();
                    index++;
                    if(index< 10) index = '0'+index;
                    // $(this).find('.post-entry-wrapper').append('<div class="">'+index+'</div>');
                    $('<div class="ccounter"><span class="current">'+index+'</span><span class="divider">/</span>'+total+'</div>').insertBefore($(this).find('.post-entry-wrapper .entry-title'));
                })
            })();

            /* -------- Image parallax scroll*/
            gsap.utils.toArray('.img_parallax_updown').forEach(container => {
                const img = container.querySelector('img');
                //fitImage(img, movementFactor);
                const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    scrub: true,
                    pin: false,
                }
                });
                tl.fromTo(img, {
                yPercent: -10,
                ease: 'none'
                }, {
                yPercent: 10,
                ease: 'none'
                });
            });

            gsap.utils.toArray('.movement').forEach(container => {
                const img = container.querySelector('img');
                //fitImage(img, movementFactor);
                const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    scrub: true,
                    pin: false,
                }
                });
                tl.fromTo(container, {
                yPercent: -12,
                ease: 'none'
                }, {
                yPercent: 12,
                ease: 'none'
                });
            });
            
            // add text to menu
            if(jQuery('.sub-nav').length){
                // jQuery('#primary-menu > .menu-item > a').append('<span class="arrow"></span>');
                $('#primary-menu .sub-nav .menu-item-text').each(function(){
                    $(this).append('<span class="cmbt"></span>');
                })
            }

            // -------- Services & Why Us
            (function(){
                var items = document.querySelectorAll('.whyus_list_item .whyus_item');
                checkDirectionAndEffect(items);
                items = document.querySelectorAll('.ourservices_list .service_item');
                checkDirectionAndEffect(items);
            })();
            
            (function(){
                let revealContainers = document.querySelectorAll(".img_reveal");
                revealContainers.forEach((container) => {
                    var clipPath;
                    //let image = container.querySelector("img");
                    let tl = gsap.timeline({
                        scrollTrigger: {
                        trigger: container,
                        //toggleActions: "restart none none reset"
                        start: 'top+=100 bottom',
                        // scrub: true,
                        }
                    });
                    if( container.classList.contains('left_to_right') ){
                        clipPath = "inset(0 100% 0 0)";
                    }else if( container.classList.contains('right_to_left') ){
                        clipPath = "inset(0 0 0 100%)";
                    }else if( container.classList.contains('top_to_bottom') ){
                        clipPath = "inset(0 0 100% 0)";
                    }else if( container.classList.contains('bottom_to_top') ){
                        clipPath = "inset(100% 0 0 0)";
                    }
                    tl.from(container, 1, {
                        clipPath: clipPath,
                        ease: 'Elastic.in',
                        scale: 1.5,
                    });

                    tl.to(container, 1, {
                        clipPath: "inset(0 0 0 0)",
                        scale: 1,
                    });
                    // tl.set(container, { autoAlpha: 1 });
                    return false;
                    
                    /*
                    tl.from(container, 1, {
                        yPercent: 0,
                        scale: 1.1,
                        opacity: 0,
                        ease: Elastic.in,
                        
                        //clipPath: "inset(12% 24% 0 24% round 0px)",
                        //webkitClipPath: "inset(12% 24% 0 24% round 0px)",
                        
                        
                        //clipPath: "polygon(20% 20%, 80% 20%, 80% 80%, 20% 80%)"
                    });
                    */
                    tl.to(container, 1, {
                        opacity: 1,
                        clipPath: "polygon(20% 20%, 80% 20%, 80% 80%, 20% 80%)",
                        //clipPath: "inset(20% 0% 20% 0% round 148px)",
                    });
                    tl.to(container, 1, {
                        opacity: 1,
                        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
                        //clipPath: "inset(0% 0% 0% 0% round 148px)",
                    });
                    tl.set(container, { autoAlpha: 1 });
                });
            })();

            /*
            gsap.utils.toArray('.img_parallax').forEach(container => {
                const img = container.querySelector('img');
                //fitImage(img, movementFactor);
                const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    scrub: true,
                    pin: false,
                }
                });
                tl.fromTo(img, {
                yPercent: -30,
                ease: 'none'
                }, {
                yPercent: 30,
                ease: 'none'
                });
            });
            */
            
            /*
            (function(){
                $('.quform-submit').each(function(){
                    $(this).append('<svg class="animated-dashes"><rect x="2px" y="2px" rx="32px" ry="32px"></rect></svg>');
                });

                $('.mini-contacts').each(function(){
                    $(this).append('<svg class="animated-dashes"><rect x="2px" y="2px" rx="25px" ry="25px"></rect></svg>');
                });
            })();
            */

            (function(){
                jQuery("#footer .menu .menu-item-has-children > a").click(function (e) {
                    e.preventDefault();
                    if (jQuery(this).parent().hasClass("opensub")) {
                        jQuery(this).parent().removeClass("opensub");
                        jQuery(this).parent().find("ul.sub-menu").slideUp();
                    } else {
                        jQuery(this).parent().addClass("opensub");
                        jQuery(this).parent().find("ul.sub-menu").slideDown();
                    }
                });
            })();
            
            //--------- our services
            (function(){
                var items = document.querySelectorAll(".ourservices_list_item .info_list_item,.our_program_item");
                var moveoutParent = 0;
                //effect when in viewport
                ScrollTrigger.batch(items, {
                    onEnter: batch => {
                        batch.forEach( (el, index) =>{
                            gsap.delayedCall(index*0.3, ()=>{
                                el.classList.add('view')
                            })
                        })
                    },
                    start: "top+=60 bottom",
                    // markers: true,
                });
            })();

            /* -------- Image parallax scroll*/
            setTimeout(function(){
                var img_parallax = gsap.utils.toArray(".img_parallax img, .video_img");
                var movementFactor = 0.15;
                img_parallax.forEach((img, i) => {
                    fitImage(img, movementFactor);
                    i = 1;
                    // the first image (i === 0) should be handled differently because it should start at the very top.
                    // use function-based values in order to keep things responsive
                    gsap.fromTo(img, {
                            y: () => i ? -movementFactor * 0.9 * img.parentNode.offsetHeight : 0
                        },
                        {
                        y: () => movementFactor * 0.9 * img.parentNode.offsetHeight,
                        ease: "linear",
                        // ease: "power1.out",
                        scrollTrigger: {
                            trigger: img.parentNode,
                            start: () => i ? "top bottom" : "-1px top", 
                            end: "bottom top",
                            scrub: true,
                            invalidateOnRefresh: true // to make it responsive
                        }
                    });
                });
            },200);

            $('.pj_info_service_title').on('click', function(){
                $(this).toggleClass('open');
                $(this).parent().find('.pj_info_service_data').toggle(300);
            });

            (function(){
                var items = document.querySelectorAll(".key_notes_slider .slide_list_item");
                ScrollTrigger.batch(items, {
                    onEnter: batch => {
                        batch.forEach( (el, index) =>{
                            gsap.delayedCall(index*0.3, ()=>{
                                el.classList.add('view')
                                /*
                                gsap.to(el, {alpha: 1, y: 0, stagger: 0.3,
                                    onComplete: ()=>{
                                        gsap.timeline({ defaults: { clearProps: true } })
                                    }
                                })
                                */    
                            })
                        })
                    },
                })
            })();

            
            this.setTimeout(function(){

                const fadeOutTimeline = gsap.timeline({
                defaults: {
                    duration: 1.5, // Duration of the fade
                    ease: "power1.out"
                },
                paused: true // Start paused, will be controlled by ScrollTrigger
                });

                fadeOutTimeline.to(".heading", {
                opacity: 0, // Fade out the element
                left: -400,
                });

                ScrollTrigger.create({
                trigger: ".heading", // The element that starts the animation
                start: "top-=320 top", // When the top of the element is 80% into the viewport
                end: "bottom+=350 top",   // When the top of the element is 20% into the viewport
                scrub: true,      // Link the animation to the scroll position
                animation: fadeOutTimeline, // Use the timeline created above
                // markers: true     // Optional: shows markers for start/end points
                });

                return false;

                const items = gsap.utils.toArray(".heading");
                items.forEach((item, index) => {
                    const tl = gsap.timeline({
                        defaults: {
                            duration: 0.5, // Duration of the fade
                            ease: "power1.out"
                        },
                        // scrollTrigger: {
                        // trigger: item,
                        // pin: true,
                        // anticipatePin: 1,
                        // scrub: 1,
                        // start: "top top",
                        // end: "+=500"
                        // }
                        paused: true,
                        scrub: true,
                    });
                    // tl.from(item, { opacity: 1, x: 0 } );
                    tl.to(item, { opacity: 0, x: -200 } );

                    ScrollTrigger.create({
                        trigger: item,
                        start: 'top-=300 top',
                        end: 'end top',
                        animation: tl,
                    })
                });
            },500);

            (function(){
                ScrollTrigger.create({
                    trigger: '.carouselscroll_inner',
                    start: "top-=150 bottom",
                    end: "bottom top",
                    scrub: !0,
                    animation: gsap.to('.carouselscroll_inner', { "--progress": 1, ease: "none" })
                })
            })();

            // headliners
            (function(){
                jQuery('.headliners_wrap').each(function(){
                    var $this = jQuery(this);
                    var items = document.querySelectorAll(".headliners_item");
                    var current_item=1;
                    var image_effect_duration = 0.6;
                    var timeScale = 0.2;
                    var tl_image = gsap.timeline();
                    // tl_image.timeScale(timeScale);
                    // tl_image.duration(2);
                    var image_scaleFrom = 1.2;
                    var image_ease = "power2.out";
                    for(var i = 0; i < items.length; i++){
                        items[i].onmouseenter = function(e){
                            var clipPathFrom = '';
                            var item_index = this.dataset.index; //read: data-index
                            var image_wrap = jQuery(this).closest('.headliners_wrap').find('.item_img[data-index="'+item_index+'"]');

                            if(current_item!=item_index){
                                jQuery(this).closest('.headliners_wrap').find('.item_img').css("z-index", 2);
                                jQuery(this).closest('.headliners_wrap').find('.item_img[data-index="'+current_item+'"]').css('z-index', 4);
                            }
                            image_wrap.css("z-index", 9);
                            jQuery(this).addClass('active');

                            var direction = gestureDirectionFrom(e,this);
                            switch(direction){
                                case "left":
                                    clipPathFrom = "inset(100% 0% 0% 0%)";
                                break;
                                case "right":
                                    clipPathFrom = "inset(0% 0% 100% 0%)";
                                break;
                                case "top":
                                    clipPathFrom = "inset(100% 0% 0% 0%)";
                                break;
                                case "bottom":
                                    clipPathFrom = "inset(0% 0% 100% 0%)";
                                break;
                            }
                            //effect
                            gsap.fromTo(image_wrap,{ 
                                    scale: image_scaleFrom,
                                    clipPath: clipPathFrom,
                                },{
                                    duration: image_effect_duration,
                                    clipPath: "inset(0% 0% 0% 0%)",
                                    ease: image_ease,
                                    overwrite:!0,
                                    onStart:()=>{
                                        gsap.to(image_wrap,{
                                            scale:1,ease:"circ.out",duration:1.4
                                        })
                                    }
                                }
                            );
                        };
                        items[i].onmouseleave = function(e){
                            var item_index = this.dataset.index; //read: data-index
                            current_item = item_index;
                            // var x = e.pageX - this.offsetLeft;
                            // var y = e.pageY - this.offsetTop;
                            var image_wrap = jQuery(this).closest('.headliners_wrap').find('.item_img[data-index="'+item_index+'"]');

                            jQuery(this).removeClass('active');
                        };
                    }
                    $this.find('.headliners_content').on('mouseleave', function(){
                        gsap.fromTo($this.find('.item_img'),{ 
                                // scale: image_scaleFrom,
                                // clipPath: "inset(0 0 0 0)",
                            },{
                                duration: image_effect_duration,
                                clipPath: "inset(100% 0% 0% 0%)",
                                ease: image_ease,
                                overwrite:!0,
                                onStart:()=>{
                                    gsap.to($this.find('.item_img'),{
                                        scale:1,ease:"circ.out",duration:1.4
                                    })
                                }
                            }
                        );
                    })
                });
            })();

            // SCROLL ON SERVICES SECTON 
            (function(){
                jQuery('.mylist_services').each(function(){
                    // return false;

                    var $this = jQuery(this);
                    var current_item = 0;
                    var item_total = $this.find('.item_heading').length;
                    var slider = gsap.timeline();
                    var autoplay = true;
                    var time_delay = 20;

                    slider.from('#indicator', { width: '0%'})
                    .to('#indicator',  time_delay, {
                        width: '100%',
                        ease: 'Power0.easeOut',
                        onComplete: function(){
                            if(current_item==item_total-1) current_item = 0;
                            else current_item++;
                            
                            // slider.reverse();
                            // slider.revert();
                            slider.restart();
                            //call active the dot

                            $this.find('.bullets > span').eq(current_item).trigger('click');

                            // $this.find('.mylist_services_data').css({'--service-item-active': current_item+1});
                        }
                    });

                    $this.find('.heading_wrap, .text_wrap').on('mouseenter', function(){
                        slider.pause();
                    }).on('mouseleave', function(){
                        slider.play();
                    });
                    //
                    $this.find('.bullets > span').on('click', function(){
                        current_item = jQuery(this).index();
                        if(!jQuery(this).hasClass('active')) {
                            jQuery(this).siblings('span').removeClass('active');
                            jQuery(this).addClass('active');
                            $this.find('.mylist_services_data').css({'--service-item-active': current_item+1});
                            slider.restart();
                        }
                    });

                    
                });

                return false;
                var currentIndex = 0;
                var animating;
                let swipePanels = gsap.utils.toArray(".pagination span");

                var intentObserver = ScrollTrigger.observe({
                    target: '#services > .wpb_column',
                    type: "wheel,touch",
                    // type: "wheel,touch,pointer",
                    onUp: () => { (!animating && gotoPanel(currentIndex + 1, true))},
                    onDown: () => !animating && gotoPanel(currentIndex - 1, false),
                    wheelSpeed: -1,
                    tolerance: 10,
                    preventDefault: true,
                    // ignore: ["mousewheel", "wheel", "touch", "pointer"], // or other event types you want to ignore for the observer
                    onPress: self => {
                        // on touch devices like iOS, if we want to prevent scrolling, we must call preventDefault() on the touchstart (Observer doesn't do that because that would also prevent side-scrolling which is undesirable in most cases)
                        ScrollTrigger.isTouch && self.event.preventDefault()
                    }
                });
                intentObserver.disable();
                function gotoPanel(index, isScrollingDown) {
                    animating = true;
                    if(index === swipePanels.length ) { //down
                        animating = false;
                        isScrollingDown && intentObserver.disable();
                    }

                    if(!isScrollingDown && index == 1){ //up
                        animating = true;
                        isScrollingDown && intentObserver.disable();
                    }
                    let target = isScrollingDown ? swipePanels[index]: swipePanels[currentIndex];
                    currentIndex = index;

                    jQuery('#mylist_services_data').css({'--service-item-active': index});
                    jQuery('#mylist_services_data .bullets span').removeClass('active');
                    jQuery('#mylist_services_data .bullets span').eq(index-1).addClass('active');
                }
                var myScrollTrigger = ScrollTrigger.create({
                    scrub: false,
                    trigger: '#services > .wpb_column',
                    pin: true,
                    start: 'top top',
                    end: 'bottom top',
                    // markers: true,
                    onEnter: (self) => {
                        currentIndex = 0;
                        console.log('onEnter');
                        intentObserver.enable();
                        gotoPanel(currentIndex + 1, true);    
                    },
                    onEnterBack: () => {
                        currentIndex = swipePanels.length;
                        console.log('onEnterBack');
                        intentObserver.enable();
                        gotoPanel(currentIndex - 1, false);
                    }
                });
            })();
            

            // ------ intro image 
            (function(){
                var items = document.querySelectorAll("#intro");
                ScrollTrigger.batch(items, {
                    onEnter: batch => {
                        batch.forEach( (el, index) =>{
                            el.classList.add('view')
                        })
                    },
                    scrub: true,
                    // duration: 1,
                    // ease: "power1.out",
                    start: "top+=50% bottom",
                    end: 'bottom+=300 bottom',
                    // markers: true,
                })
            })();


            //--------- HOme list item
            (function(){
                var items = document.querySelectorAll(".home_list_item  .home_item");
                var moveoutParent = 0;
                //effect when in viewport
                ScrollTrigger.batch(items, {
                    onEnter: batch => {
                        batch.forEach( (el, index) =>{
                            gsap.delayedCall(index*0.4, ()=>{
                                el.classList.add('view')
                            })
                        })
                    },
                    start: "top+=30 bottom",
                });
                
                //check for Parent
                $('.home_list_item').on('mouseleave', function(){
                }).on('mouseenter',function(){
                    
                });
                //check for Items
                $('.home_list_item .home_item').on('mouseenter', function(){
                    // jQuery(this).addClass('active');
                }).on('mouseleave', function(){
                    // jQuery(this).removeClass('active');
                });
                //effect when over hover
                var time = 0.35;
                for(var i = 0; i < items.length; i++){
                    items[i].onmouseenter = function(e){
                        var direction = gestureDirectionFrom(e,this);
                        var overlay = this.getElementsByClassName('overlay')[0];
                        this.classList.add('active');
                        switch(direction){
                            case "left":
                            case "top":
                                overlay.style.top = "-100%";
                                gsap.to(overlay, time, {top: '0%'});
                                break;
                            case "right":
                            case "bottom":
                                overlay.style.top = "100%";
                                gsap.to(overlay, time, {top: '0%'});
                                break;
                        }
                    };
                    items[i].onmouseleave = function(e){
                        var direction = gestureDirectionFrom(e,this);
                        var overlay = this.getElementsByClassName('overlay')[0];
                        this.classList.remove('active');
                        switch(direction){
                            case "left":
                            case "top":
                                gsap.to(overlay, time, {top: '-100%'});
                                break;
                            case "right":
                            case "bottom":
                                gsap.to(overlay, time, {top: '100%'});
                                break;
                        }
                    };
                }
            })();

            // ------ FAQ
            (function(){
                var items = document.querySelectorAll(".vc_do_toggle");
                ScrollTrigger.batch(items, {
                    onEnter: batch => {
                        batch.forEach( (el, index) =>{
                            gsap.delayedCall(index*0.1, ()=>{
                                el.classList.add('view');
                            });
                        })
                    },
                    start: "top+=50 bottom",
                })
            })();

            var swiper = new Swiper(".key_notes_slider", {
                // slidesPerView: 3.9,
                slidesPerView: 'auto',
                spaceBetween: 30,
                observer: true,
                observeParents: true,
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
                scrollbar: {
                    el: '.swiper-scrollbar',
                    draggable: true,
                },
                breakpoints: {
                    // when window width is >= 640px
                    200: {
                        
                    },
                    480: {
                    //    slidesPerView: 1.4, 
                    },
                    1024: {
                        
                    },
                    1400: {
                        // slidesPerView: 3.5,
                    },
                    1500: {
                        // slidesPerView: 3.9,
                    },
                },
            });
        });
    } else {
        console.log("jQuery is not loaded");
    }
})();
